import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "items-input-box"
};
import { nextTick, ref, watch } from "vue";
// eslint-disable-next-line no-undef

export default {
  __name: 'ItemsInput',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:value'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    // eslint-disable-next-line no-undef
    const emits = __emit;
    const tags = ref(props.value);
    const inputValue = ref('');
    const inputVisible = ref(false);
    const InputRef = ref(null);
    watch(() => props.value, newValue => {
      tags.value = newValue;
    });
    const handleClose = tag => {
      tags.value.splice(tags.value.indexOf(tag), 1);
    };
    const showInput = () => {
      inputVisible.value = true;
      nextTick(() => {
        InputRef.value?.input?.focus();
      });
    };
    const handleInputConfirm = () => {
      if (inputValue.value) {
        tags.value.push(inputValue.value);
      }
      inputVisible.value = false;
      inputValue.value = '';
      emits('update:value', tags.value);
    };
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, tag => {
        return _openBlock(), _createBlock(_component_el_tag, {
          key: tag,
          closable: "",
          "disable-transitions": false,
          onClose: $event => handleClose(tag)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(tag), 1)]),
          _: 2
        }, 1032, ["onClose"]);
      }), 128)), inputVisible.value ? (_openBlock(), _createBlock(_component_el_input, {
        key: 0,
        ref_key: "InputRef",
        ref: InputRef,
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => inputValue.value = $event),
        class: "w-20",
        size: "small",
        onKeyup: _withKeys(handleInputConfirm, ["enter"]),
        onBlur: handleInputConfirm
      }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        class: "button-new-tag",
        size: "small",
        onClick: showInput
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" + 新增 ")])),
        _: 1
      }))]);
    };
  }
};